export const DEFAULT_CITY = "Bangalore"